import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/cryptogram.json";
import fr from "@/locales/fr/puzzle-types/cryptogram.json";

export const CRYPTOGRAM_NS = "puzzle-types/cryptogram";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerCryptogramTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", CRYPTOGRAM_NS))
    i18n.addResourceBundle("en", CRYPTOGRAM_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", CRYPTOGRAM_NS))
    i18n.addResourceBundle("fr", CRYPTOGRAM_NS, fr, true, true);
}
